import './Navigation.scss';
import * as React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import * as Core from 'components/core';
import NavigationSection from './NavigationSection';
import { productForPath } from 'figure-53-documentation';
type Props = {
  path: string;
  currentPageHeadings: Array<{
    value: string;
    depth: number;
  }>;
  currentHeading: string | undefined | null;
};
type State = {
  versionDropdownExpanded: boolean;
};
export default class Navigation extends React.Component<Props, State> {
  state = {
    versionDropdownExpanded: false,
  };
  toggleVersionDropdown = () => {
    this.setState({
      versionDropdownExpanded: !this.state.versionDropdownExpanded,
    });
  };
  closeVersionDropdown = () => {
    if (this.state.versionDropdownExpanded) {
      this.setState({
        versionDropdownExpanded: false,
      });
    }
  };
  render() {
    const { product, version, productVersions, pages } = productForPath(
      'qlab',
      this.props.path,
    );
    const currentProductVersions = productVersions.filter((v) => {
      return v.version <= ENV.QLAB_CURRENT_MAJOR_VERSION;
    });
    const { currentPageHeadings, currentHeading } = this.props;
    const { versionDropdownExpanded } = this.state;
    return (
      <div>
        {version != null && product != null && (
          <div onMouseLeave={this.closeVersionDropdown}>
            <div className="DocsNavigation-product">
              <Core.Link
                className={classnames('DocsNavigation-product-version', {
                  'is-current':
                    this.props.path === version.path &&
                    !versionDropdownExpanded,
                })}
                to={version.path}
              >
                {version.name}
              </Core.Link>
              {currentProductVersions && currentProductVersions.length > 0 && (
                <button
                  className="DocsNavigation-product-versionsButton"
                  data-testid="docs-version-navigation-button"
                  onClick={this.toggleVersionDropdown}
                  aria-label={
                    versionDropdownExpanded
                      ? 'Close Versions'
                      : 'Switch QLab Version'
                  }
                >
                  ↕
                </button>
              )}
            </div>
            {currentProductVersions && versionDropdownExpanded && (
              <div className="DocsNavigation-product-productVersions">
                {currentProductVersions.map((otherVersion) => (
                  <Link
                    key={otherVersion.slug}
                    to={otherVersion.path}
                    data-testid={`docs-version-navigation-${otherVersion.slug}`}
                    className={classnames(
                      'DocsNavigation-product-productVersions-version',
                      {
                        'is-current': version.slug === otherVersion.slug,
                      },
                    )}
                  >
                    {otherVersion.name}
                  </Link>
                ))}
              </div>
            )}
          </div>
        )}
        {!versionDropdownExpanded && pages != null && (
          <ul>
            {pages.map((page, index) => (
              <NavigationSection
                key={index}
                path={this.props.path}
                page={page as any}
                currentPageHeadings={currentPageHeadings}
                currentHeading={currentHeading}
              />
            ))}
          </ul>
        )}
      </div>
    );
  }
}
